import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/report-vulnerability/page.jsx")